export const getParsedData = (tableHTML) => {
    if (!tableHTML) {
        return [];
    }
    const parser = new DOMParser();
    const doc = parser.parseFromString(tableHTML, 'text/html');
    const trElements = Array.from(doc.querySelectorAll('tr'));
    const parsedData = trElements.map((element) => Array.from(element.querySelectorAll('td')).map((item) => {
        const colSpan = item.getAttribute('colspan');
        const rowSpan = item.getAttribute('rowspan');
        return {
            value: item.innerHTML,
            style: item.getAttribute('style'),
            colSpan: colSpan ? parseInt(colSpan, 10) : undefined,
            rowSpan: rowSpan ? parseInt(rowSpan, 10) : undefined,
        };
    }));
    return parsedData;
};
export const getTableCells = (tableRows) => {
    if (!tableRows || !tableRows.length) {
        return {
            bodyCellsData: [],
            headCellsData: [],
            isEmptyHeaderRow: true,
            isEmptyTable: true,
        };
    }
    const bodyCellsData = [];
    let headCellsData;
    let isEmptyHeaderRow = false;
    let isEmptyTable = false;
    tableRows.forEach((cell, rowIndex) => {
        if (rowIndex === 0) {
            headCellsData = cell;
        }
        else {
            bodyCellsData.push(cell);
        }
    });
    if (headCellsData?.every((item) => item.value === '' || item.value === '&nbsp;')) {
        isEmptyHeaderRow = true;
    }
    isEmptyTable = bodyCellsData?.every((row) => row.every((item) => item.value === '' || item.value === '&nbsp;'));
    return {
        bodyCellsData,
        headCellsData,
        isEmptyHeaderRow,
        isEmptyTable,
    };
};
export function isDataTableEmpty(props) {
    const { tableData } = props;
    const { isEmptyHeaderRow, isEmptyTable } = getTableCells(getParsedData(tableData));
    return (!props ||
        !tableData ||
        (isEmptyHeaderRow && isEmptyTable) ||
        (!isEmptyHeaderRow && isEmptyTable));
}
